<template>
  <div class="show-card">
    <h2>{{ show.title }}</h2>
    <div class="date">{{ formattedDate }}</div>
    <div class="venue">{{ show.venue }}</div>
    <div class="location">{{ show.location }}</div>
    <img
      v-if="posterUrl"
      :src="posterUrl"
      :alt="show.title"
      class="poster"
      @click="$emit('poster', this.show.poster)"
    />
  </div>
</template>

<script>
export default {
  name: 'ShowCard',

  props: {
    show: Object,
  },
  computed: {
    formattedDate() {
      return new Date(this.show.date).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    posterUrl() {
      return this.show.poster
        ? `/media/images/shows/thumbnails/${this.show.poster}`
        : null;
    },
  },
};
</script>

<style scoped>
.show-card {
  background: #121212;
  color: #f0f0f0;
  padding: 1rem;
  border-radius: 20px;
  max-width: 400px;
  width: 80vw;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  text-align: center;
  margin: auto;
  margin-bottom: 5rem;
}

h2 {
  margin: 0 0 0.8rem 0;
  color: #909078;
  font-size: 1.8rem;
}

.poster {
  width: 90%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 1rem;
  cursor: pointer;
}

.date {
  font-size: 1.4rem;
  color: white;
}

.venue {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0.5rem 0;
  color: #7f7b7b;
}

.location {
  font-size: 1.2rem;
  font-weight: bold;
  color: #7f7b7b;
  margin-bottom: 1rem;
}
</style>
